import { API } from "@/lib/api";
import {
  APIService,
  FetchListRequest,
  SuccessFetchListResponse,
} from "@/services/api";
import { ReadContractorStudent } from "@/types/contractorStudent";

export const ContractorStudentsService = new APIService<
  ReadContractorStudent,
  ReadContractorStudent
>(API.ContractorsStudents);

export const fetchContractorStudentsList = (
  params: FetchListRequest<ReadContractorStudent> = {},
) =>
  ContractorStudentsService.getList<
    SuccessFetchListResponse<ReadContractorStudent>
  >(params);
